import React from "react";

interface BreadCrumbProps {
  title?: string;
  pageTitle?: string;
}

/**
 * The page heading, on desktop only.
 *
 * `AppHeader` already shows the page name in the fixed top bar, so on a phone
 * this was a second copy of the same words costing a line of vertical space on
 * all 41 pages — the scarcest thing on a 375px screen. Kept above `md`, where
 * the space is free and the repetition reads as a heading rather than a
 * duplicate.
 */
export default function BreadCrumb({ title, pageTitle }: BreadCrumbProps) {
  if (!title && !pageTitle) return null;
  return (
    <div className="mb-5 hidden md:block">
      <h2 className="text-lg font-semibold text-gray-900">
        {title ?? pageTitle}
      </h2>
    </div>
  );
}
